export default __webpack_public_path__ + "static/media/Training_services.7b58371b.png";